module.exports = __webpack_public_path__ + "img/std.979846c6.jpg";